<ion-header>
  <ion-toolbar class="custom-toolbar">
    <div class="header-content">
      <!-- Menu button on the left -->
      <ion-buttons slot="start">
        <ion-menu-button></ion-menu-button>
      </ion-buttons>

      <div class="molhy-logo" *ngIf="!isPasswordVerified">
          <img src="assets/images/molhy-light.png">
      </div>

      <!-- Logo in the center -->
      <div class="header-logo" *ngIf="isPasswordVerified">
        <div class="logo-molhy"></div>
      </div>

      <!-- Right side elements -->
      <div class="header-right">
        <!-- Language switcher -->
        <div class="language-switcher">
          <ion-icon name="globe-outline" class="globe-icon"></ion-icon>
          <ion-select [(ngModel)]="selectedLanguage" (ionChange)="switchLanguage($event)" interface="popover">
            <ion-select-option value="en">English</ion-select-option>
            <ion-select-option value="ta">தமிழ் Tamil</ion-select-option>
            <ion-select-option value="bm">Bahasa Melayu</ion-select-option>
          </ion-select>
        </div>

        <!-- Profile section -->
        <div class="profile-section" routerLink="/account">
          <ion-icon name="person-circle-outline"></ion-icon>
          <span class="profile-name" *ngIf="isLoggedIn">
            {{ firstName }}
          </span>
        </div>
      </div>
    </div>
  </ion-toolbar>
</ion-header>

  <!-- Developer Password Protection Screen -->
  <div *ngIf="!isPasswordVerified">
  </div>

<ion-content [scrollEvents]="true" *ngIf="isPasswordVerified">
  <div class="main-content-wrapper">
    <div class="home-section" #homeSection>
      <!-- Animated GIF container -->
      <div class="gif-overlay"></div>
      <div class="logo-container" #logoContainer>
        <div class="logo-molhy"></div>
      </div>
      <h2 class="main-title slide-in">{{ 'Multilingual Education Games' | translate }} <span
          class="beta-badge">{{ 'Beta' | translate }}</span></h2>

      <div class="floating-shapes">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
      </div>
    </div>

    <!-- AI Games Section -->
    <section class="game-modules-preview">
      <h2 class="section-title">
        <span class="title-decoration"></span>
        <div class="ai-title-icon-wrapper">
          <ion-icon name="sparkles" class="ai-title-icon"></ion-icon>
          <div class="ai-title-glow-ring"></div>
        </div>
        {{ 'Artificial Intelligence (AI) Learning Games' | translate }}
        <span class="title-decoration"></span>
      </h2>

      <div class="games-grid">
        <!-- Search Word -->
        <div class="game-card" routerLink="/searchword">
          <div class="game-icon search-word"></div>
          <!-- <ion-icon name="sparkles-outline" class="ai-icon purple-icon" title="AI-Powered"></ion-icon> -->
          <div class="ai-tooltip">AI-Generated Content</div>
          <div class="game-title">
            <h3>{{ 'Search' | translate }}</h3>
          </div>
          <div class="game-info">
            <p>{{ 'Search the grid to find all the hidden words quickly.' | translate }}</p>
          </div>
        </div>

        <!-- Blank Word -->
        <div class="game-card" routerLink="/blankword">
          <div class="game-icon blank-word"></div>
          <div class="ai-tooltip">AI-Generated Content</div>
          <div class="game-title">
            <h3>{{ 'Blank' | translate }}</h3>
          </div>
          <div class="game-info">
            <p>{{ 'Fill in the blank of the missing word letters.' | translate }}</p>
          </div>
        </div>

        <!-- Error Word -->
        <div class="game-card" routerLink="/errorword">
          <div class="game-icon error-word"></div>
          <div class="ai-tooltip">AI-Generated Content</div>
          <div class="game-title">
            <h3>{{ 'Error' | translate }}</h3>
          </div>
          <div class="game-info">
            <p>{{ 'Find and replace incorrect letters on the words.' | translate }}</p>
          </div>
        </div>

        <!-- Jumble Word -->
        <div class="game-card" routerLink="/jumbleword">
          <div class="game-icon jumble-word"></div>
          <div class="ai-tooltip">AI-Generated Content</div>
          <div class="game-title">
            <h3>{{ 'Jumble' | translate }}</h3>
          </div>
          <div class="game-info">
            <p>{{ 'Unscramble the words to reveal the jumbled phrase.' | translate }}</p>
          </div>
        </div>

        <!-- Guess Word -->
        <div class="game-card" routerLink="/guessword">
          <div class="game-icon guess-word"></div>
          <div class="ai-tooltip">AI-Generated Content</div>
          <div class="game-title">
            <h3>{{ 'Guess' | translate }}</h3>
          </div>
          <div class="game-info">
            <p>{{ 'Determine the word challenge with first letter revealed.' | translate }}</p>
          </div>
        </div>

        <!-- Group Word -->
        <div class="game-card" routerLink="/groupword">
          <div class="game-icon group-word"></div>
          <div class="ai-tooltip">AI-Generated Content</div>
          <div class="game-title">
            <h3>{{ 'Group' | translate }}</h3>
          </div>
          <div class="game-info">
            <p>{{ 'Match words that share a common theme.' | translate }}</p>
          </div>
        </div>
        <!-- Pair Game -->
        <div class="game-card" routerLink="/pairsgame">
          <div class="game-icon pair-word"></div>
          <div class="ai-tooltip">AI-Generated Content</div>
          <div class="game-title">
            <h3>{{ 'Pair' | translate }}</h3>
          </div>
          <div class="game-info">
            <p>{{ 'Pair the words with their correct matches.' | translate }}</p>
          </div>
        </div>


        <!-- Mark Game -->
        <div class="game-card" routerLink="/mark">
          <div class="game-icon mark-game"></div>
          <div class="ai-tooltip">AI-Generated Content</div>
          <div class="game-title">
            <h3>{{ 'Mark' | translate }}</h3>
          </div>
          <div class="game-info">
            <p>{{ 'Answer clues on your grid and get a full row to win.' | translate }}</p>
          </div>
        </div>

      </div>
    </section>

    <!-- Critical Thinking Games Section -->
    <section class="game-modules-preview interactive-games">
      <h2 class="section-title">
        <span class="title-decoration"></span>
        <div class="interactive-title-icon-wrapper">
          <ion-icon name="game-controller" class="interactive-title-icon"></ion-icon>
          <div class="interactive-title-glow-ring"></div>
        </div>
        {{ 'Higher-order Thinking Skills (HOTS) Games' | translate }}
        <span class="title-decoration"></span>
      </h2>

      <div class="games-grid">
        <!-- Create Word -->
        <div class="game-card" routerLink="/createword">
          <div class="game-icon create-word"></div>
          <div class="game-title">
            <h3>{{ 'Create' | translate }}</h3>
          </div>
          <div class="game-info">
            <p>{{ 'Create words always including the mandatory center letter.' | translate }}</p>
          </div>
        </div>

        <!-- Reform Word -->
        <div class="game-card" routerLink="/reformword">
          <div class="game-icon reform-word"></div>
          <div class="game-title">
            <h3>{{ 'Reform' | translate }}</h3>
          </div>
          <div class="game-info">
            <p>{{ 'Rearrange letters horizontally and vertically to form words.' | translate }}</p>
          </div>
        </div>

        <!-- Change Word -->
        <div class="game-card" routerLink="/changeword">
          <div class="game-icon change-word"></div>
          <div class="game-title">
            <h3>{{ 'Change' | translate }}</h3>
          </div>
          <div class="game-info">
            <p>{{ 'Replace a letter and create a new word.' | translate }}</p>
          </div>
        </div>

        <!-- Picture Word -->
        <div class="game-card" routerLink="/pictureword">
          <div class="game-icon picture-word"></div>
          <div class="game-title">
            <h3>{{ 'Picture' | translate }}</h3>
          </div>
          <div class="game-info">
            <p>{{ 'Interpret visual hints to uncover words.' | translate }}</p>
          </div>
        </div>

        <!-- Stack Word -->
        <div class="game-card" routerLink="/stackword">
          <div class="game-icon stack-word"></div>
          <div class="game-title">
            <h3>{{ 'Stack' | translate }}</h3>
          </div>
          <div class="game-info">
            <p>{{ 'Arrange falling letters into correct order to build words.' | translate }}</p>
          </div>
        </div>

        <!-- Cross Word -->
        <div class="game-card" routerLink="/crossword">
          <div class="game-icon cross-word"></div>
          <div class="game-title">
            <h3>{{ 'Cross' | translate }}</h3>
          </div>
          <div class="game-info">
            <p>{{ 'Solve the crossword puzzle using the given helpful clues.' | translate }}</p>
          </div>
        </div>

      </div>
    </section>

    <!-- Language Mastery Games Section -->
    <section class="game-modules-preview language-games">
      <h2 class="section-title">
        <span class="title-decoration"></span>
        <div class="language-title-icon-wrapper">
          <ion-icon name="language" class="language-title-icon"></ion-icon>
          <div class="language-title-glow-ring"></div>
        </div>
        {{ 'Language Mastery Games' | translate }}
        <span class="title-decoration"></span>
      </h2>

      <div class="games-grid">
        <!-- Match Word -->
        <div class="game-card" routerLink="/matchword">
          <div class="game-icon match-word"></div>
          <div class="game-title">
            <h3>{{ 'Match' | translate }}</h3>
          </div>
          <div class="game-info">
            <p>{{ 'Identify the correct words in multiple languages.' | translate }}</p>
          </div>
        </div>

        <!-- Audio Word -->
        <div class="game-card" routerLink="/audioword">
          <div class="game-icon audio-word"></div>
          <div class="game-title">
            <h3>{{ 'Audio' | translate }}</h3>
          </div>
          <div class="game-info">
            <p>{{ 'Listen to words and identify their correct language.' | translate }}</p>
          </div>
        </div>

      </div>
    </section>

    <!-- AI-Powered Features Section -->
    <section class="ai-features">
      <div class="ai-features-wrapper">
        <!-- Tech background elements -->
        <div class="ai-tech-background">
          <div class="circuit-lines">
            <div class="circuit-line cl-1"></div>
            <div class="circuit-line cl-2"></div>
            <div class="circuit-line cl-3"></div>
            <div class="circuit-line cl-4"></div>
            <div class="circuit-line cl-5"></div>
            <div class="circuit-node cn-1"></div>
            <div class="circuit-node cn-2"></div>
            <div class="circuit-node cn-3"></div>
          </div>
          <div class="data-grid">
            <div class="data-square"></div>
            <div class="data-square"></div>
            <div class="data-square"></div>
            <div class="data-square"></div>
            <div class="data-square"></div>
            <div class="data-square"></div>
          </div>
          <div class="binary-stream">
            <div class="binary-text">10110101</div>
            <div class="binary-text">01001110</div>
            <div class="binary-text">11010010</div>
          </div>
        </div>

        <div class="ai-header">
          <h2 class="ai-title">{{ 'AI-Powered Gamified Learning' | translate }}</h2>
          <div class="ai-subtitle">{{ 'Game experiences crafted by Artifical Intelligence' | translate }}</div>
          <div class="ai-decoration">
            <div class="ai-line" routerLink="/syllabus"></div>
            <div class="ai-circle" routerLink="/language"></div>
            <div class="ai-line"></div>
          </div>
        </div>

        <div class="ai-cards-container">
          <!-- Smart Content -->
          <div class="ai-card">
            <div class="ai-card-glow"></div>
            <div class="ai-card-content">
              <div class="ai-icon-wrapper">
                <ion-icon name="sparkles-outline" class="ai-icon"></ion-icon>
                <div class="ai-pulse"></div>
              </div>
              <h3 class="ai-card-title">{{ 'Adaptive Content' | translate }}</h3>
              <p class="ai-card-text">{{ 'AI generates custom challenges based on requested topics.' | translate }}</p>
            </div>
            <div class="tech-corner"></div>
          </div>

          <!-- Real-Time Feedback -->
          <div class="ai-card">
            <div class="ai-card-glow"></div>
            <div class="ai-card-content">
              <div class="ai-icon-wrapper">
                <ion-icon name="flash-outline" class="ai-icon"></ion-icon>
                <div class="ai-pulse"></div>
              </div>
              <h3 class="ai-card-title">{{ 'Smart Generation' | translate }}</h3>
              <p class="ai-card-text">{{ 'AI creates curated content based on topic relevance and accuracy.' | translate
                }}</p>
            </div>
            <div class="tech-corner"></div>
          </div>

          <!-- Performance Analytics -->
          <div class="ai-card">
            <div class="ai-card-glow"></div>
            <div class="ai-card-content">
              <div class="ai-icon-wrapper">
                <ion-icon name="analytics-outline" class="ai-icon"></ion-icon>
                <div class="ai-pulse"></div>
              </div>
              <h3 class="ai-card-title">{{ 'Learning Analytics' | translate }}</h3>
              <p class="ai-card-text">{{ 'AI tracks learning streaks, mastery levels, and engagement patterns.' |
                translate }}</p>
            </div>
            <div class="tech-corner"></div>
          </div>

          <!-- Multilingual Mastery -->
          <div class="ai-card">
            <div class="ai-card-glow"></div>
            <div class="ai-card-content">
              <div class="ai-icon-wrapper">
                <ion-icon name="language-outline" class="ai-icon"></ion-icon>
                <div class="ai-pulse"></div>
              </div>
              <h3 class="ai-card-title">{{ 'Language Intelligence' | translate }}</h3>
              <p class="ai-card-text">{{ 'AI enables seamless multilingual modules with precise adaptations.' |
                translate }}</p>
            </div>
            <div class="tech-corner"></div>
          </div>
        </div>

        <div class="ai-particles">
          <div class="particle p1"></div>
          <div class="particle p2"></div>
          <div class="particle p3"></div>
          <div class="particle p4"></div>
        </div>

        <div class="ai-brain">
          <div class="brain-connections"></div>
        </div>

        <!-- Neural network visualization -->
        <div class="neural-network">
          <div class="neuron-layer input-layer">
            <div class="neuron"></div>
            <div class="neuron"></div>
            <div class="neuron"></div>
          </div>
          <div class="neuron-layer hidden-layer">
            <div class="neuron"></div>
            <div class="neuron"></div>
            <div class="neuron"></div>
            <div class="neuron"></div>
          </div>
          <div class="neuron-layer output-layer">
            <div class="neuron"></div>
            <div class="neuron"></div>
          </div>
          <div class="neural-connections"></div>
        </div>

        <!-- Digital rain effect -->
        <div class="digital-rain">
          <div class="rain-column"></div>
          <div class="rain-column"></div>
          <div class="rain-column"></div>
          <div class="rain-column"></div>
        </div>
      </div>
    </section>

    <!-- Benefits Section -->
    <div class="benefits-section">
      <h2 class="section-title">
        <span class="title-decoration"></span>
        {{ 'Benefits of Learning Games' | translate }}
        <span class="title-decoration"></span>
      </h2>
      <div class="benefits-grid">
        <!-- Active Engagement -->
        <div class="benefit-item">
          <div class="icon-wrapper">
            <ion-icon name="game-controller-outline"></ion-icon>
          </div>
          <div class="benefit-content">
            <h3>{{ 'Active Engagement' | translate }}</h3>
            <p>{{ 'Interactive learning through games keeps students engaged and reduces passive learning.' | translate
              }}</p>
          </div>
        </div>

        <!-- Motivation Boost -->
        <div class="benefit-item">
          <div class="icon-wrapper">
            <ion-icon name="rocket-outline"></ion-icon>
          </div>
          <div class="benefit-content">
            <h3>{{ 'Motivation Boost' | translate }}</h3>
            <p>{{ 'Rewards and challenges drive learners to achieve goals and enhance skills.' | translate }}</p>
          </div>
        </div>

        <!-- Improved Retention -->
        <div class="benefit-item">
          <div class="icon-wrapper">
            <ion-icon name="library-outline"></ion-icon>
          </div>
          <div class="benefit-content">
            <h3>{{ 'Improved Retention' | translate }}</h3>
            <p>{{ 'Interactive practice enhances memory retention through engaging repetition.' | translate }}</p>
          </div>
        </div>

        <!-- Creativity Stimulation -->
        <div class="benefit-item">
          <div class="icon-wrapper">
            <ion-icon name="bulb-outline"></ion-icon>
          </div>
          <div class="benefit-content">
            <h3>{{ 'Creativity Boost' | translate }}</h3>
            <p>{{ 'Problem-solving games inspire creative thinking and innovative solutions.' | translate }}</p>
          </div>
        </div>

        <!-- Confidence Building -->
        <div class="benefit-item">
          <div class="icon-wrapper">
            <ion-icon name="trending-up-outline"></ion-icon>
          </div>
          <div class="benefit-content">
            <h3>{{ 'Build Confidence' | translate }}</h3>
            <p>{{ 'Instant feedback helps track progress and master new skills effectively.' | translate }}</p>
          </div>
        </div>

        <!-- Stress Reduction -->
        <div class="benefit-item">
          <div class="icon-wrapper">
            <ion-icon name="happy-outline"></ion-icon>
          </div>
          <div class="benefit-content">
            <h3>{{ 'Reduce Stress' | translate }}</h3>
            <p>{{ 'Fun gaming elements create a relaxed and positive learning environment.' | translate }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer wrapper -->
    <div class="footer-wrapper">
      <!-- Footer container -->
      <div class="footer-container">
        <div class="footer-content">
          <div class="footer-logo">
            <img src="assets/images/molhy-light.png" alt="MOLHY Logo">
          </div>
          <div class="footer-links">
            <a routerLink="/about" class="footer-link">About Us</a>
            <a routerLink="/policies" class="footer-link">Policies</a>
          </div>
          <div class="footer-social">
            <a href="https://www.facebook.com/molhycom" class="social-icon" target="_blank"><ion-icon
                name="logo-facebook"></ion-icon></a>
            <a href="https://www.x.com/molhycom" class="social-icon" target="_blank">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="x-icon">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </a>
            <a href="https://www.instagram.com/molhycom" class="social-icon" target="_blank"><ion-icon
                name="logo-instagram"></ion-icon></a>
            <a href="https://www.youtube.com/@molhycom" class="social-icon" target="_blank"><ion-icon
                name="logo-youtube"></ion-icon></a>
            <a href="https://www.tiktok.com/@molhycom" class="social-icon" target="_blank"><ion-icon
                name="logo-tiktok"></ion-icon></a>
            <a href="https://www.threads.net/@molhycom" class="social-icon" target="_blank">
              <svg aria-label="Threads" viewBox="0 0 192 192" xmlns="http://www.w3.org/2000/svg" class="threads-icon">
                <path class="x19hqcy"
                  d="M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z">
                </path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer>
  <div class="footer-bottom">
    <span>© 2025 MOLHY.COM · <a href="https://otpam.com" target="_blank" class="footer-link">OTPAM SDN BHD
        (1446394-V)</a>. All Rights Reserved.</span>
  </div>
</ion-footer>